import React from 'react';
import { Box, BoxProps, Flex } from '@opendoor/bricks/core';
import { useCurrentWidth } from 'shared/helpers/hooks/useCurrentWidth';
import { useMeasure } from 'shared/helpers/hooks/reactUseOverrides';
import { space } from '@opendoor/bricks/theme/eero';
import { Footer } from 'platform/components/layout/Footer';
import { isOpendoorAppEvoWebView } from 'shared/helpers/globals';

const MAX_CONTAINER_WIDTH = '1144px';
const SINGLE_COLUMN_WIDTH = '928px';

/**
 * Component that renders a layout for the new VA pages for the SSVA Targeting Experiment.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const TwoColumnLayout: React.FC<{
  rightComponent?: React.ReactNode;
  maxContainerWidth?: BoxProps['maxW'];
  gap?: number;
  hideRightColumn?: boolean;
}> = ({
  children,
  rightComponent,
  maxContainerWidth = MAX_CONTAINER_WIDTH,
  gap = 8,
  hideRightColumn = false,
}) => {
  const screenWidth = useCurrentWidth();
  const [containerRef, { width: containerWidth }] = useMeasure();
  return (
    <Flex
      ref={containerRef}
      width="100%"
      maxW={!hideRightColumn ? maxContainerWidth : SINGLE_COLUMN_WIDTH}
      flexDirection={['column', null, 'row']}
      gridGap={gap}
    >
      <Box width={['100%', null, hideRightColumn ? '100%' : '70%']}>
        {children}
        <Box mt="11">{!isOpendoorAppEvoWebView && <Footer />}</Box>
      </Box>
      {!hideRightColumn && (
        <Box
          width={['100%', null, containerWidth * 0.3 - space[gap]]}
          // 144px to align with the grey box on the left column
          mt={[0, null, '144px']}
          mb={10}
          right={(screenWidth - containerWidth) / 2}
        >
          {rightComponent && <Box>{rightComponent}</Box>}
        </Box>
      )}
    </Flex>
  );
};
